import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./app";
import "./instrument";
import * as Sentry from "@sentry/react";
import { sentryEnabled } from "./instrument";
import { installTranslateDomGuard } from "@/lib/translate-dom-guard";

installTranslateDomGuard();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = sentryEnabled
  ? createRoot(rootElement, {
      onCaughtError: Sentry.reactErrorHandler(),
      onUncaughtError: Sentry.reactErrorHandler(),
    })
  : createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
